import firebase from 'firebase'
import 'firebase/auth'
import 'firebase/firestore'
import config from '../config'

export const GOOGLE_PROVIDER = firebase.auth.GoogleAuthProvider.PROVIDER_ID
export const FACEBOOK_PROVIDER = firebase.auth.FacebookAuthProvider.PROVIDER_ID

// only initialize firebase once
if (!firebase.apps.length) {
    firebase.initializeApp(config.firebase)

    // enable cache/offline persistence
    firebase.firestore().settings({
        cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
    })
    firebase.firestore().enablePersistence()
        .catch(function(err) {
            if (err.code === 'failed-precondition') {
                // Multiple tabs open, persistence can only be enabled
                // in one tab at a a time.
            } else if (err.code === 'unimplemented') {
                // The current browser does not support all of the
                // features required to enable persistence
            }
        });
}

export function getDb() {
    return firebase.firestore()
}

export function serverTimestamp() {
    return firebase.firestore.FieldValue.serverTimestamp()
}

export function clientTimestamp(date = new Date()) {
    return firebase.firestore.Timestamp.fromDate(date)
}

// This will return false until firebase has initialized, even if the user is logged in
export function isUserLoggedIn() {
    return firebase.auth().currentUser != null
}

export function getUser() {
    if (!isUserLoggedIn()) {
        return undefined
    }

    return getAuth().currentUser
}

export function getAuth() {
    return firebase.auth()
}

export function signOut() {
    if (isUserLoggedIn()) {
        getAuth().signOut()
    }
}

export function getUserIdToken() {
    if (!isUserLoggedIn()) {
        return Promise.resolve('')
    }

    return getUser().getIdToken(true)
}

export function onAuthStateChanged(callback) {
    return getAuth().onAuthStateChanged(callback)
}

export function generateDocumentId() {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const length = 20
    let id = ''

    for (let i = 0; i < length; i++) {
        id += possible.charAt(Math.floor(Math.random() * possible.length))
    }

    return id
}

export default firebase